import axiosLogin from "global/helpers/axiosLogin";
import axiosInstance from "../../../helpers/axiosInstance";
import {
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_SETUSUARIO,
  LOGIN_SUCCESS,
  LOGOUT_USER,
} from "../../ActionTypes";

export const setUsuarioAuth = (usuario) => (dispatch) => {
  if (usuario !== null) {
    sessionStorage.token = usuario.token;
  }
  dispatch({
    type: LOGIN_SETUSUARIO,
    payload: usuario,
  });
};

export const login =
  ({ txtDni, tag }, nextStep) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        // .post("/auth", {
        .post("/shared/authCheckinQr", {
          nro_documento: txtDni,
          idTerminal: tag,
        })
        .then((res) => {
          sessionStorage.token = res.data.token;
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
          if (nextStep) {
            nextStep(true, res.data);
          }
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGIN_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const loginApp =
  ({ txtDni, txtPassword }, sectorTurno, nextStep) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post("/shared/Auth/legacy-login", {
          // .post("/authAutoterminal", {
          password: txtPassword,
          nro_documento: txtDni,
          sectorTurno,
        })
        .then((res) => {
          // sessionStorage.token = res.data.token;
          // dispatch({
          //   type: LOGIN_SUCCESS,
          //   payload: res.data,
          // });
          if (nextStep) {
            nextStep(true, res.data);
          }
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          // dispatch({
          //   type: LOGIN_ERROR,
          //   payload: error,
          // });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const logoutAuth = () => (dispatch) => {
  dispatch({ type: LOGOUT_USER });
};